import React, { useState } from "react";
import dayjs from "dayjs";
import { Avatar, Box } from "@mui/material";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { StyledCard, TruncatedDescription, Footer, Actions, SemiBoldTitle, AgentTypeChip, StatusChip, CategoryChip, CardHeader, CardHeaderLeft, CardHeaderRight, CardFooterInfo, CardFooterLabel, MoreIconButton, TitleAndChips, ChipsRow, EditButton, ChatButton } from "./AgentCard.styled";
import { RoundedButton } from "../../../../elements";
import VerticalButton from "../../../../elements/verticalButton/VerticalButton";
import ConfirmationModal from "../../../../elements/v2/modals/ConfirmationModal";
import SuccessModal from "../../../../elements/v2/SuccessModal/SuccessModal";
import ShareAgentModal from "../../AsistantManagement/components/ShareAgentModal/ShareAgentModal";
import Alerts from "../../../../elements/v2/Alerts/Alerts";
import { useNavigate } from "react-router-dom";
import { useStore } from "../../../../hooks";
import { AgentDeletionMessages, PermissionCodes, PermissionLevels } from "../../../../utils/enums";
import { useUserCheckPermissions } from "../../../../hooks/useUserCheckPermissions";

const AgentCard = ({ 
  avatar, 
  title, 
  jobTitle,
  description, 
  updatedBy, 
  lastModified, 
  onEdit, 
  onUse, 
  onClick, 
  type,
  prompt_id,
  status,
  category,
  owner,
  agentId,
  customerId,
  onShare,
  onRemove,
  onDuplicate
}) => {
  const { checkPermission, warningMessageTitle, showAlert, closeAlert } = useUserCheckPermissions();

  const handleEdit = (e) => {
    if (e && e.stopPropagation) e.stopPropagation();
    const hasLangchainPrompt = prompt_id && prompt_id.includes('langchain');
    onEdit && onEdit(hasLangchainPrompt);
  };

  const handleDuplicate = (e) => {
    if (e && e.stopPropagation) e.stopPropagation();
    onDuplicate && onDuplicate(agentId, customerId);
  };

  const handleShare = (e) => {
    if (e && e.stopPropagation) e.stopPropagation();
    onShare && onShare(agentId, customerId);
  };

  const handleRemove = (e) => {
    if (e && e.stopPropagation) e.stopPropagation();
    onRemove && onRemove(agentId, customerId);
  };

  const handleCardClick = (e) => {
    if (e.target.closest('.vertical-button-container')) {
      return;
    }
    onClick && onClick(e);
  };

  return (
    <StyledCard onClick={handleCardClick}>
      <CardHeader>
        <CardHeaderLeft>
          <Avatar src={avatar} alt={title} sx={{ width: 36, height: 36, marginRight: "12px" }} />
          <TitleAndChips>
            <SemiBoldTitle>{title}</SemiBoldTitle>
            <ChipsRow>
              {category && <CategoryChip>{category}</CategoryChip>}
              {status && <StatusChip status={status}>{status}</StatusChip>}
            </ChipsRow>
          </TitleAndChips>
        </CardHeaderLeft>
        <CardHeaderRight>
          { checkPermission(PermissionCodes.AGENTS_UPDATE, PermissionLevels.UPDATE) && (
            <EditButton kind="edit" onClick={handleEdit}>Edit</EditButton>
          )}
          <ChatButton kind="primary" onClick={e => { e.stopPropagation(); onUse(); }}>Chat</ChatButton>
          <div className="vertical-button-container">
            <VerticalButton
              dataTestId="vertical-button-agent-card"
              options={[
                checkPermission(PermissionCodes.AGENTS_UPDATE, PermissionLevels.UPDATE) ? { title: 'Edit', onClick: handleEdit } : null,
                checkPermission(PermissionCodes.AGENTS_DUPLICATE, PermissionLevels.CREATE) ? { title: 'Duplicate', onClick: handleDuplicate } : null,
                checkPermission(PermissionCodes.PLAYGROUND_SHARE, PermissionLevels.CREATE) ? { title: 'Share', onClick: handleShare } : null,
                { title: 'Remove', onClick: handleRemove }
              ].filter(Boolean)}
            />
          </div>
        </CardHeaderRight>
      </CardHeader>

      <TruncatedDescription>{description}</TruncatedDescription>

      <Footer>
        <CardFooterInfo>
          <CardFooterLabel>Owner</CardFooterLabel> {owner} &nbsp;&nbsp;
          <CardFooterLabel>Last updated</CardFooterLabel> {lastModified ? dayjs(lastModified).format("MM/DD/YYYY") : "Unknown"}
        </CardFooterInfo>
      </Footer>
    </StyledCard>
  );
};

export default AgentCard;
